import React from 'react'
import Image from 'gatsby-image'
import styled from 'styled-components'
import media from '../styles/media'
import '../assets/css/fonts.css'
import 'font-awesome/css/font-awesome.css'
import Truncate from 'react-truncate';
import  HTMLRenderer  from  'react-html-renderer'

const ContainerCarousel = styled.div`
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-bottom: 30px;
  display: inline-block;
  margin: 15px;
  background-color: #fff;
  overflow: hidden;
  width: 488px;
  height: 400px;
  font-size: 13px;
  position: relative;
  .sizeImage {
    width: 100%;
  }
  ${media.sm`
    width: 90%;
    height: 100%;
    padding-bottom:10px;
  `};
  .sizeIcon {
    color: #0000e2;
    font-size: 60px;
    ${media.sm`
       font-size: 40px;
    `};
  }

  .titleItemServices {
    color: #0000e2;
    font-size: 30px;
    font-family: 'Prelo Slab';
    text-align: left;
    ${media.sm`
        font-size: 22px;
    `};
  }

  .textGovernment{
    color: #6f6f6e;
    font-family: 'Prelo-Book';
    font-size: 16px;
    text-align: left;
  }

}
`

const Service = ({ id, name, description, image }) => {
  return (
    <ContainerCarousel>
      <Image
        className="sizeImage"
        resolutions={image.node.childImageSharp.resolutions}
        alt={name}
      />
      <div className="row">
        <div className="col-md-2 col-xs-2">
          {id === '1' ? (
            <i className="demo-icon icon-iconos-almesa-11 sizeIcon">&#xe80a;</i>
          ) : id === '2' ? (
            <i className="demo-icon icon-iconos-almesa-12 sizeIcon">&#xe80b;</i>
          ) : id === '3' ? (
            <i className="demo-icon icon-iconos-almesa-13 sizeIcon">&#xe80c;</i>
          ) : (
            <i className="demo-icon icon-iconos-almesa-14 sizeIcon">&#xe80d;</i>
          )}
        </div>
        <div className="col-md-10 col-xs-10">
          <p className="titleItemServices" dangerouslySetInnerHTML={{ __html: name }} />
            <HTMLRenderer 
                html={description}
                />
        </div>
      </div>
    </ContainerCarousel>
  )
}

export default Service
